/**
 * Hardcoded list of topics for the user-facing help / contact form.
 *
 * The list is frontend-only (no admin config UI) — change here to update
 * the picker. Each entry exposes:
 *   - value    : the slug sent to the backend (`POST /contact`)
 *   - label    : user-facing title
 *   - keywords : extra words matched by the in-form search box
 *
 * "Other" is always shown last and reveals a free-text "reason" input
 * (sent as `customReason` on submit).
 */
export const CONTACT_TOPICS = [
  {
    value: 'account',
    label: 'Account / Login',
    keywords: ['login', 'password', 'account', 'signin', 'access', 'sign', 'auth'],
  },
  {
    value: 'bug',
    label: 'Bug Report',
    keywords: ['bug', 'error', 'broken', 'crash', 'not working', 'wrong', 'issue'],
  },
  {
    value: 'data',
    label: 'Data / Record Issue',
    keywords: ['data', 'record', 'child', 'vaccine', 'growth', 'missing', 'incorrect'],
  },
  {
    value: 'feature',
    label: 'Feature Request',
    keywords: ['feature', 'request', 'suggest', 'new', 'add', 'enhancement'],
  },
  {
    value: 'howto',
    label: 'Question / How-To',
    keywords: ['how', 'question', 'help', 'use', 'guide', 'tutorial'],
  },
  {
    value: 'feedback',
    label: 'Feedback / Suggestion',
    keywords: ['feedback', 'comment', 'opinion', 'review', 'thoughts'],
  },
  {
    value: 'other',
    label: 'Other',
    keywords: [],
  },
];

/** Topic whose `value` is "other" — reveals the custom-reason input. */
export const OTHER_TOPIC = 'other';

/**
 * Case-insensitive search across label + keywords.
 * Returns the full list when `query` is empty/blank.
 */
export function searchTopics(query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return CONTACT_TOPICS;
  return CONTACT_TOPICS.filter((t) => {
    if (t.label.toLowerCase().includes(q)) return true;
    return t.keywords.some((k) => k.toLowerCase().includes(q));
  });
}
